
import BaseService from './BaseService'

export interface WebshotPayload {
    url: string,
    storagePath: string,
    bucketName?: string,
    width?: number,
    height?: number,
    fullPage?: boolean,
}

class WebshotService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }
  screenshot = (payload: WebshotPayload) => this.requests.post(`/screenshot`, payload)
}

const instance = new WebshotService(BaseService.servicesConfig.WebshotService)

export default instance